export default function getDisplayFormattedDate(params) {
    const { dateString } = params;
    let res = '';
    const dt = new Date(Date.parse(dateString));
    try {
        res = new Intl.DateTimeFormat([], { year: 'numeric', month: 'numeric', day: 'numeric', timeZone: 'UTC' }).format(dt);
    }
    catch (_a) {
        console.warn('isDate column contained non-date value');
    }
    return res;
}
